import { httpClient } from "@/lib/http-client";
import {
  CreateTestimonialResponse,
  Testimonial,
  TestimonialQuery,
} from "./types";
import { CollectionForm } from "../utils/schema";

export const createTestimonial = async (payload: FormData) => {
  const response = await httpClient.post<CreateTestimonialResponse>(
    "testimonials",
    payload,
  );

  return response;
};

export const fetchTestimonial = async (filters: TestimonialQuery) => {
  const queryParams = new URLSearchParams();
  const { sortCriterion, ...others } = filters;

  Object.entries({ ...sortCriterion, ...others }).forEach(([key, value]) => {
    if (typeof value === "boolean" || !!value) {
      if (Array.isArray(value)) {
        value.forEach((v) => queryParams.append(key, v));
      } else {
        queryParams.append(key, value.toString());
      }
    }
  });

  const response = await httpClient.get<Testimonial[]>(
    `/testimonials?${queryParams.toString()}`,
  );

  return response;
};

export const getForm = async (id: string) => {
  const response = await httpClient.get<CollectionForm>(`/forms/${id}`);

  return response;
};
